.profilesList {
  max-height: 330px;
  overflow: auto;
  margin: 0 calc(-1 * var(--space-xs));
}

.hint {
  display: block;
  margin-top: var(--space-xs);
  color: var(--color-accent-1);
  font-size: 0.8em;
}
